import React from 'react';
import Navbar from '@/components/Navbar';
import SiteFooter from '@/components/SiteFooter';
import { Reveal, useSiteContent } from '@/components/Editorial';

export default function LegalPage({ page }) {
  const c = useSiteContent(page);
  if (!c) return <div style={{ minHeight: '100vh', backgroundColor: '#fff' }}><Navbar /></div>;

  return (
    <div style={{ backgroundColor: '#fff', color: '#000', minHeight: '100vh' }}>
      <Navbar />

      <section className="border-b" style={{ borderColor: '#E5E5E5' }}>
        <div className="container-app py-24 md:py-32 max-w-3xl">
          <Reveal>
            <h1 className="font-bold mb-3" style={{ fontSize: 'clamp(2rem, 4vw, 3.25rem)', lineHeight: 1.02, letterSpacing: '-0.03em' }}>{c.title}</h1>
            <p className="text-xs uppercase tracking-[0.2em] mb-8" style={{ color: '#999' }}>{c.updated}</p>
            <p className="text-base leading-relaxed mb-12" style={{ color: '#444' }}>{c.intro}</p>
            <div>
              {c.sections.map((s, i) => (
                <div key={i} className="py-8" style={{ borderTop: i === 0 ? '1px solid #000' : '1px solid #E5E5E5' }}>
                  <div className="flex items-baseline gap-3 mb-3">
                    <span className="text-xs font-semibold tabular-nums" style={{ color: '#999' }}>{String(i + 1).padStart(2, '0')}</span>
                    <h2 className="text-lg font-bold">{s.heading}</h2>
                  </div>
                  <p className="text-sm leading-relaxed pl-7" style={{ color: '#555' }}>{s.body}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
